import ichigojam from "refractor/ichigojam";
export default ichigojam;